import { FormGroup, FormParagraph } from '@ksyos/design-system';
import { ActivityType } from '@common/enums';
import { getSelectedLanguage } from '@frontend/translate';
import type { AdminProcess } from '../adminProcessDetailsTypes';

type NoPayoutReasonProps = {
    noPayoutReason: AdminProcess['noPayoutReason'];
};

export function NoPayoutReason({ noPayoutReason }: NoPayoutReasonProps) {
    if (!noPayoutReason) {
        return null;
    }

    const translate = getSelectedLanguage();
    const label = `${translate.finance.reasonNoPaymentShort} (${translate.activityTypeEnum[ActivityType.request]})`;

    return (
        <FormGroup label={label}>
            <FormParagraph>{translate.noPayoutReasonEnum[noPayoutReason]}</FormParagraph>
        </FormGroup>
    );
}
